import React from 'react';
import logo from '../Icones/logo jabil.svg';

import '../Estilos/EstiloBotao.css';
import '../Estilos/Container.css';
import '../Estilos/Fontes.css';
import '../Estilos/Componentes.css';

export default function LogoHeader() {
  return (
    <div className="LogoNome">
      <img
        src={require('../Icones/logo jabil.svg').default}
        height={54}
        width={220}
        style={{ paddingRight: 5 }}
      />
      <div className="Divisor"></div>
      <h3 id="LogoTexto">COGNOS</h3>
    </div>
  );
}
